import { Controller } from "@hotwired/stimulus"

// Controls capacity field visibility from service (individual_service => capacity 1, hidden).
export default class extends Controller {
  static values = {
    services: Object
  }

  static targets = ["capacityField"]

  connect() {
    this.updateCapacityVisibility()
  }

  onServiceChange() {
    this.updateCapacityVisibility()
  }

  get firstSelectedServiceId() {
    const select = this.element.querySelector('select[name*="service_id"]')
    const value = select?.value
    return value && value !== "" ? value : null
  }

  updateCapacityVisibility() {
    if (!this.hasCapacityFieldTarget) return

    const serviceId = this.firstSelectedServiceId
    if (!serviceId) return

    const capacity = this.servicesValue[serviceId]

    // individual_service => 1: hide field and set capacity to 1; else show and default to 2
    if (capacity === 1) {
      this.capacityFieldTarget.classList.add("hidden")
      const input = this.capacityFieldTarget.querySelector("input[type='number']")
      if (input) input.value = "1"
    } else {
      this.capacityFieldTarget.classList.remove("hidden")
      const defaultCapacity = capacity != null && capacity >= 1 ? capacity : 2
      const input = this.capacityFieldTarget.querySelector("input[type='number']")
      if (input && (!input.value || input.value === "0")) input.value = defaultCapacity
    }
  }
}
